// Axios
import { AxiosResponse } from "axios";
import { _axios } from "../../Base_Axios_Config/_axios";
// Axios

// Models
import { I_Message } from "../../../Models/interfaces";
import { I_GroupOnGroupSendingData } from "../../../Models/sendingDataSchema";
// Models

export const editGroupOnGroupService = (_data: {
  userToken: string;
  _data: I_GroupOnGroupSendingData & {
    tenantId: string;
  };
}): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: {};
  }>
> => {
  return _axios.post(`/groups/group-on-group-accesses/update`, _data._data, {
    headers: {
      Authorization: `Bearer ${_data.userToken}`,
    },
  });
};
